import { render, staticRenderFns } from "./sh_OpenBookingTranslationProject.vue?vue&type=template&id=2ffe53aa&"
import script from "./sh_OpenBookingTranslationProject.vue?vue&type=script&lang=js&"
export * from "./sh_OpenBookingTranslationProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports